import { graphql, Link, useStaticQuery } from "gatsby";
import React, { useMemo } from "react";
import getLocationPath from "../../services/getLocationPath";
import { LinkItem } from "./footer/desktop";
import { useLoc } from "../../hooks/useLoc";
export const DestinationList = ({}: {}) => {
    const data = useStaticQuery(graphql`
        query DestinationListQuery {
            bestDestinations: commonDataJson {
                headerList {
                    bestCountries {
                        continent
                        country {
                            ...CountryBase
                        }
                    }
                    bestRegions {
                        continent
                        region {
                            ...RegionStub
                        }
                    }
                    counts {
                        continent
                        count
                    }
                }
            }
        }
    `);
    const loc = useLoc();
    const dataList = useMemo(() => {
        const countryMap = {};
        const regionMap = {};
        data.bestDestinations.headerList.bestCountries.forEach((item) => {
            if (!countryMap[item.continent]) {
                countryMap[item.continent] = [];
            }
            countryMap[item.continent].push(item.country);
        });
        data.bestDestinations.headerList.bestRegions.forEach((item) => {
            if (!regionMap[item.continent]) {
                regionMap[item.continent] = [];
            }
            regionMap[item.continent].push(item.region);
        });
        return { countryMap, regionMap };
    }, []);
    const mainContinents = ["africa", "asia", "europe", "central-america"];
    const otherContinents = [
        "north-america",
        "south-america",
        "middle-east",
        "australia"
    ];
    return (
        <div className="flex w-full flex-col md:flex-row items-stretch justify-center mdmax:gap-4 mdmax:mt-3">
            <div className="flex flex-col md:flex-row items-start justify-center gap-4 md:gap-2 px-8 lg:gap-8 lg:px-12 xl:gap-20 xxl:gap-28 w-4/5 mdmax:w-full">
                {mainContinents.map((continent) => {
                    const countries = dataList.countryMap[continent] || [];
                    const regions = dataList.regionMap[continent] || [];
                    const continentName = loc("common.continents." + continent);
                    const continentCount =
                        data.bestDestinations.headerList.counts.find(
                            (item) => item.continent === continent
                        )?.count || 0;
                    if (countries.length === 0 && regions.length === 0) {
                        return null;
                    }
                    return (
                        <div
                            key={continent}
                            className="flex flex-col flex-wrap items-start justify-start xs:flex-row md:m-4 md:flex-col mdmax:w-full mdmax:gap-y-1"
                        >
                            <Link
                                to={`/${continent}-weather-climate/`}
                                className="basis-full"
                            >
                                <h2 className="m-2 flex items-center text-xl font-bold capitalize text-sh-red">
                                    {continent.replace("-", " ")}
                                    <span className="mx-2 text-base normal-case text-sh-red">
                                        -{"> "}
                                    </span>
                                </h2>
                            </Link>
                            {countries.map((country) => (
                                <div
                                    key={country.slug}
                                    className="my-2 basis-1/2 text-sm font-bold underline md:mx-2 mdmax:px-2"
                                >
                                    <LinkItem
                                        key={country.slug}
                                        to={getLocationPath({
                                            location: country,
                                            isCountryInstance: true,
                                            monthIndex: 12
                                        })}
                                        text={country.name}
                                    ></LinkItem>
                                </div>
                            ))}
                            {regions.map((region) => (
                                <div
                                    key={region.slug}
                                    className="my-2 basis-1/2 text-sm font-bold underline md:mx-2 mdmax:px-2"
                                >
                                    <LinkItem
                                        key={region.slug}
                                        to={getLocationPath({
                                            location: region,
                                            isCountryInstance: false,
                                            monthIndex: 12
                                        })}
                                        text={region.name}
                                    ></LinkItem>
                                </div>
                            ))}
                            <div className="my-2 basis-1/2 text-sm font-medium text-zinc-400 underline md:mx-2 mdmax:px-2">
                                <LinkItem
                                    key={continent}
                                    to={`/${continent}-weather-climate/`}
                                    text={`${continentCount} others`}
                                ></LinkItem>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="flex-1"></div>
            <div className="flex flex-col items-start justify-start bg-zinc-100 px-8 lg:px-12 py-4 mdmax:pb-6">
                <h2 className="m-2 text-xl font-bold capitalize text-sh-red">
                    Other popular
                </h2>
                {otherContinents.map((continent) => {
                    const continentName = loc("common.continents." + continent);
                    return (
                        <div
                            key={continent}
                            className="mx-2 my-2 text-sm font-bold underline"
                        >
                            <LinkItem
                                key={continent}
                                to={`/${continent}-weather-climate/`}
                                text={continentName}
                            ></LinkItem>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
